var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { colors, fontSizes, notificationBar, statusColors } from '../../../defaultTheme';
import Inline from '../../spacing/Inline';
import Inset from '../../spacing/Inset';
const ChipBase = styled(Inset) `
  background-color: ${({ disabled, hasError }) => {
    if (disabled)
        return colors.lightGrey;
    if (hasError)
        return statusColors.error.background;
    return colors.white;
}};
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  border: 1px solid ${colors.lightGrey};
  border: ${({ hasError }) => hasError
    ? `2px solid ${notificationBar.error.badgeBackground}`
    : `1px solid ${colors.lightGrey}`};
  box-shadow: 0px 1px 2px ${colors.lightGrey};
  overflow: hidden;
  border-radius: 9999px;
  height: 32px;
  font-size: ${fontSizes.small}px;
  font-family: Open Sans;
  color: ${({ theme }) => theme.chip.text};
  user-select: none;

  &:hover {
    ${({ disabled, theme }) => !disabled ? `background-color: ${theme.chip.hover};` : ''}
  }

  &:after {
    ${({ disabled, theme }) => disabled
    ? ''
    : `
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(
      circle,
      ${theme.chip.animated} 10%,
      transparent 10%
    );
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform 0.5s, opacity 1s;
    `}
  }

  &:active:after {
    transform: scale(0, 0);
    opacity: 0.1;
    transition: 0s;
  }

  ${({ css }) => css}
`;
const Text = styled.p `
  font-size: ${fontSizes.root}px;
  text-align: center;
`;
const Chip = (_a) => {
    var { icon, alt, iconLeft, disabled, hasError, onClick, onKeyPress, css, children, className, role = 'button', tabIndex = 0 } = _a, props = __rest(_a, ["icon", "alt", "iconLeft", "disabled", "hasError", "onClick", "onKeyPress", "css", "children", "className", "role", "tabIndex"]);
    return (React.createElement(ChipBase, Object.assign({}, props, { disabled: disabled, hasError: hasError, onClick: !disabled ? onClick : () => null, onKeyPress: !disabled && onKeyPress ? onKeyPress : () => null, css: css, className: className, vertical: "medium", role: role, tabIndex: tabIndex }),
        icon && iconLeft && (React.createElement(React.Fragment, null,
            icon,
            " ",
            React.createElement(Inline, { size: "small" }))),
        React.createElement(Text, null, children),
        icon && !iconLeft && (React.createElement(React.Fragment, null,
            React.createElement(Inline, { size: "small" }),
            " ",
            icon))));
};
export default Chip;
